module.exports = __webpack_public_path__ + "src/assets/de.02d2a31f.png";